/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Radio = (function () {

    function Radio () {

        Monet.UI.Fields.TextField.apply(this, arguments);
        this.createBaseStructure();
        this.value = false;

        this.createElement = function () {

            this.label.className = 'radio_label';
            this.input = document.createElement('input');
            this.input.type = 'radio';
            this.rootEl.insertBefore(this.input, this.label);
        };

        this.setChecked = function (value) {
            this.value = false;
            if(typeof value === "boolean") {
                this.value = value ;
            }

            if(this.input){
                this.input.checked = this.value;
            }
        };

        this.setInputId = function (id) {
            this.label.setAttribute('for', id);
            this.input.id = id;
        };

        this.setInputValue = function () {
            if (this.input) {
                this.input.value = this.value;
            }
        };

        this.render = function () {
            this.createElement();
            this.setInputValue();
            return this.rootEl;

        };

    }

    return Radio;

}());